import * as React from "react";
import { Tooltip, Button, Position, ButtonGroup } from "./externals";
export class TextTools extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.iframeRef = React.createRef();
        this.printFile = (content) => {
            var _a, _b;
            if (this.iframeRef.current !== null) {
                this.iframeRef.current.innerHTML = "";
                const textElement = document.createElement("span");
                textElement.innerHTML = content;
                textElement.style.fontFamily = "Consolas";
                textElement.style.fontSize = "13px";
                textElement.style.whiteSpace = "pre-wrap";
                const doc = (_a = this.iframeRef.current.contentWindow) === null || _a === void 0 ? void 0 : _a.document;
                doc === null || doc === void 0 ? void 0 : doc.body.appendChild(textElement);
                this.iframeRef.current.focus();
                (_b = this.iframeRef.current.contentWindow) === null || _b === void 0 ? void 0 : _b.print();
            }
        };
        this.copyFile = (content) => {
            const textarea = document.createElement("textarea");
            textarea.value = content;
            textarea.setAttribute("readonly", "");
            textarea.style.position = "absolute";
            textarea.style.left = "-9999px";
            const parent = document.body;
            parent.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            parent.removeChild(textarea);
        };
    }
    render() {
        const { title, onSave, content } = this.props;
        return (React.createElement("div", null,
            React.createElement("label", { className: "stdout-label", style: { paddingBottom: "10px" } }, title),
            React.createElement(ButtonGroup, { style: { paddingLeft: "10px", paddingBottom: "10px" } },
                React.createElement(Tooltip, { content: "Copy content", hoverCloseDelay: 0, position: Position.TOP },
                    React.createElement(Button, { icon: "duplicate", onClick: () => this.copyFile(content), "aria-label": "copy" })),
                React.createElement(Tooltip, { content: "Download file", hoverCloseDelay: 0, position: Position.TOP },
                    React.createElement(Button, { icon: "download", onClick: onSave, "aria-label": "download" })),
                React.createElement(Tooltip, { content: "Print file", hoverCloseDelay: 0, position: Position.TOP },
                    React.createElement(Button, { icon: "print", onClick: () => this.printFile(content), "aria-label": "print" }))),
            React.createElement("iframe", { title: "Print iframe", ref: this.iframeRef, style: { display: "none" } })));
    }
}
//# sourceMappingURL=TextTools.js.map